import React, {useState} from "react";
import PropTypes from 'prop-types';
import CONST from "../../config/CONST";
import {useSelector} from "react-redux";
import {getSelectedCustomer, getUserConfigurations} from "../../store/slices/userConfigurationsSlice";
import {getAppData} from "../../store/slices/appSlice";
import {useTranslation} from "react-i18next";
import InfoTooltip from "../InfoTooltip/InfoTooltip";

const RadioButton = (props) => {

    const {
        onCheck,
        defaultChecked,
        value,
        product
    } = props;

    const { t } = useTranslation();

    const [isChecked, setIsChecked] = useState(value);
    const appData = useSelector(getAppData);
    const selectedCustomer = useSelector(getSelectedCustomer) || appData.touchpointConfig.defaults.customer;
    const selectedVehicleType = appData.input.vehicleType || appData.touchpointConfig.defaults.vehicleCondition;
    const allUserConfigurations = useSelector(getUserConfigurations) || [];
    const userConfiguration = allUserConfigurations.find(c => c.EIM === appData.input.EIM && c.selectedProduct && c.vehicleType === selectedVehicleType && c.customer === selectedCustomer);

    const _onClick = () => {
        onCheck(!isChecked);
        setIsChecked(!isChecked);
    }

    return (
        <>
            <div className={`${CONST.CSS_NAMESPACE}RadioButton`}>
                <input
                    className={userConfiguration?.productTypeCode === value ? `${CONST.CSS_NAMESPACE}RadioButton-is-checked` : ''}
                    onChange={_onClick}
                    value={value}
                    type={"radio"}
                    name={"Product Selection"}
                    checked={defaultChecked && (!userConfiguration?.productTypeCode || userConfiguration?.productTypeCode === value)}
                />
                <label className={`${CONST.CSS_NAMESPACE}RadioButton-label`}>
                    {t(appData.rates[selectedCustomer+"_"+product.productTypeCode].find(c => c.rateId === product.rateID).rentalProductName)}
                </label>
            </div>
            <InfoTooltip
                id={`tooltip-${value}`}
                content={appData.rates[selectedCustomer+"_"+product.productTypeCode].find(c => c.rateId === product.rateID)[`rentalProductDescription_`+ appData.config.lang]}
            />

        </>
    );
};

RadioButton.propTypes = {
    onCheck: PropTypes.func.isRequired,
    defaultChecked: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
    product: PropTypes.object.isRequired
};

export default RadioButton;
